import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaTimesCircle,
} from 'react-icons/fa';
import './styles/TimeLog.css';

const TimeLog = ({ logs = [] }) => {
  const today = new Date();
  const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
  const [weekStart, setWeekStart] = useState(startOfWeek);

  // Get week days range
  const getWeekRange = () => {
    const end = new Date(weekStart);
    end.setDate(weekStart.getDate() + 6);
    return `${weekStart.toDateString()} - ${end.toDateString()}`;
  };

  // Filter logs for the current week
  const filteredLogs = logs.filter((log) => {
    const logDate = new Date(log.date);
    return (
      logDate >= weekStart &&
      logDate <= new Date(weekStart.getTime() + 6 * 24 * 60 * 60 * 1000)
    );
  });

  // Group logs by date
  const logsByDate = filteredLogs.reduce((acc, log) => {
    if (!acc[log.date]) acc[log.date] = [];
    acc[log.date].push(log);
    return acc;
  }, {});

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Approved':
        return <FaCheckCircle className="status-icon approved" />;
      case 'Pending Approval':
        return <FaExclamationCircle className="status-icon pending" />;
      case 'Correction needed':
        return <FaTimesCircle className="status-icon correction" />;
      default:
        return null;
    }
  };

  const handlePrevWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(weekStart.getDate() - 7);
    setWeekStart(newStart);
  };

  const handleNextWeek = () => {
    const newStart = new Date(weekStart);
    newStart.setDate(weekStart.getDate() + 7);
    setWeekStart(newStart);
  };

  return (
    <div className="my-time-log-container">
      <div className="header-timelog">
        <FaChevronLeft className="nav-arrow" onClick={handlePrevWeek} />
        <h2 className="header-title">{getWeekRange()}</h2>
        <FaChevronRight className="nav-arrow" onClick={handleNextWeek} />
      </div>

      <div className="log-list">
        {filteredLogs.length === 0 ? (
          <p>No logs this week</p>
        ) : (
          Object.keys(logsByDate).map((date, i) => (
            <div key={i} className="log-day-group">
              <h3 className="log-day">{date}</h3>
              {logsByDate[date].map((entry, index) => (
                <div key={index} className="log-entry">
                  <div className="log-details">
                    <h4 className="job-title">{entry.job}</h4>
                    <p className="log-time">
                      {entry.type}:{' '}
                      <span className="time-value">{entry.time}</span>
                    </p>
                  </div>
                  <div className="log-status">
                    {getStatusIcon(entry.status)}
                    <span className="status-text">{entry.status}</span>
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TimeLog;
